import React from "react";
import { useState } from "react";
import classes from "./Notification.module.css";
import { IoMdNotificationsOutline } from "react-icons/io";
import { useEffect } from "react";
import { useSettings } from "../../Hooks/useUnifiedApi";
import { useAuth } from "../../Hooks/useAuth";
import notification_live_trip from "../../Assets/notification_live_trip.png";
import notification_live_trip_end from "../../Assets/notification_live_trip_end.png";
import shift_start_icon from "../../Assets/shift_start_icon.png";
import shift_end_icon from "../../Assets/shif_end_icon.png";
import notification_department_add from "../../Assets/notification_department_add.png";
import notification_rider from "../../Assets/notification_rider.png";

let count = "";
const Notification = (props) => {
  const [isNotificationIconClicked, setIsNotificationIconClicked] =
    useState(false);
  const [notificationData, setNotificationData] = useState([]);
  const [apiAvailable, setApiAvailable] = useState(true); // Track if API is available

  // Use unified auth hook instead of direct localStorage access
  const { user, isAuthenticated } = useAuth();

  // Use unified API hook for notifications (settings service has notification endpoints)
  const { customCall, error } = useSettings();

  // Handle notification response
  const handleNotificationResponse = (data) => {
    console.log('🔔 Notification API response:', data);

    if (data && data.NotificationList && Array.isArray(data.NotificationList)) {
      setNotificationData(data.NotificationList);
      count = data.NotificationList.length;
      setApiAvailable(true);
    } else {
      // Handle case where API returns unexpected data structure
      console.warn('⚠️ Notification API returned unexpected data structure:', data);
      setNotificationData([]);
      count = 0;
    }
  };

  useEffect(() => {
    if (!isAuthenticated || !user) {
      console.log('🔔 User not authenticated - skipping notification fetch');
      setNotificationData([]);
      count = 0;
      return;
    }

    const fetchNotifications = async () => {
      try {
        console.log('🔔 Fetching notifications from API...');

        const response = await customCall('getNotification', {
          emailID: user.email || localStorage.getItem('user') || '',
          corporateID: user.corporateId || localStorage.getItem('corpId') || '',
          roleID: user.roleId || localStorage.getItem('roleId') || ''
        });

        handleNotificationResponse(response);
      } catch (error) {
        console.error(' Failed to fetch notifications:', error);

        // Handle 404 or API unavailable gracefully
        if (error.message && error.message.includes('404')) {
          console.warn('🔔 Notification API not available (404) - using fallback');
          setApiAvailable(false);
        }

        setNotificationData([]);
        count = 0;
      }
    };

    fetchNotifications();
  }, [customCall, isAuthenticated, user]);

  useEffect(() => {
    if (props.isAdminPhotoClicked) setIsNotificationIconClicked(false);
  }, [props.isAdminPhotoClicked]);

  // Handle API errors
  useEffect(() => {
    if (error) {
      console.warn('🔔 Notification API error:', error);
      // Don't show error to user, just log it and continue with empty notifications
      setNotificationData([]);
      count = 0;

      // If it's a 404 error, mark API as unavailable to stop polling
      if (error.message && error.message.includes('404')) {
        console.warn('🔔 Notification API unavailable (404) - stopping polling');
        setApiAvailable(false);
      }
    }
  }, [error]);

  const notificationIconClicked = () => {
    count = null;
    localStorage.setItem("notificationClickedTime", new Date().getTime());
    props.setIsAdminPhotoClicked(false);
    setIsNotificationIconClicked((prev) => !prev);
  };

  return (
    <React.Fragment>
      {/* <CommonConsole tag={"kaisa hai bhai"} log={notificationData}/> */}
      <div className={classes.notificationIcon}>
        <IoMdNotificationsOutline onClick={notificationIconClicked} />
        {isNotificationIconClicked && (
          <React.Fragment>
            <div
              className={classes.backdrop}
              onClick={() => setIsNotificationIconClicked(false)}
            ></div>
            <div className={classes.notificationPanel}>
              <div className={classes.topBorder}></div>
              <div className={classes.header}>Notification</div>
              <hr />
              <div className={classes.notificationdataContainer}>
                {notificationData.length > 0 ? (
                  notificationData.map((ele, index) => {
                    return (
                      <div key={index} className={classes.data}>
                        <img
                          className={classes.icon}
                          src={
                            ele.title.toLowerCase().includes("department")
                              ? notification_department_add
                              : ele.title.toLowerCase().includes("rider")
                              ? notification_rider
                              : ele.title.toLowerCase().includes("trip")
                              ? ele.title.toLowerCase().includes("start")
                                ? notification_live_trip
                                : notification_live_trip_end
                              : ele.title.toLowerCase().includes("start")
                              ? shift_start_icon
                              : shift_end_icon
                          }
                          alt="Notification icon"
                        />
                        <div style={{ width: "-webkit-fill-available" }}>
                          {/* <div> */}
                          <span className={classes.title}>{ele.title}</span>
                          {/* </div> */}
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              fontSize: "11px",
                              marginTop: "3px",
                            }}
                          >
                            <span className={classes.status}>{ele.status}</span>
                            <p className={classes.time}>{ele.time}</p>
                          </div>
                          <div
                            style={{
                              marginTop: "10px",
                              borderTop: "1px solid #80808073",
                            }}
                          ></div>
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p className={classes.content}>No new notifications</p>
                )}
              </div>
            </div>
          </React.Fragment>
        )}
        {count && <span className={classes.notificationCount}>{count}</span>}
      </div>
    </React.Fragment>
  );
};

export default Notification;
